<template>
    <div v-loading="loading">
        <el-form class="form" label-width="200px" ref="ruleForm" :model="cbConfig" >
            <el-form-item label="当前库存：" prop="roomId">
                <el-input-number v-model="cbConfig.currentCbStock" :step="1000"></el-input-number>
               
            </el-form-item>
           <el-form-item label="库存阈值下线" prop="roomId">
                <el-input-number v-model="cbConfig.cbStockDown" :step="1000"></el-input-number>
                <label>>>>下线赔率%</label><el-input-number v-model="cbConfig.cbStockDownOdds" :step="1" :min="0" :max="50"></el-input-number>
            </el-form-item>
            <el-form-item label="库存阈值中线" prop="roomId">
                <el-input-number v-model="cbConfig.cbStockCent" :step="1000"></el-input-number>
                 <label>>>>中线赔率%</label><el-input-number v-model="cbConfig.cbStockCentOdds" :step="1" :min="0" :max="55"></el-input-number>
            </el-form-item>
            <el-form-item label="库存阈值上线" prop="roomId">
                <el-input-number v-model="cbConfig.cbStockUpper" :step="1000" ></el-input-number>
                <label>>>>上线赔率%</label><el-input-number v-model="cbConfig.cbStockUpperOdds" :step="1" :min="0" :max="60"></el-input-number>
            </el-form-item>
            <el-form-item label="库存增加配置%" prop="roomId">
                 <el-input-number v-model="cbConfig.inStock"  :min="1" :max="100" label="库存减少配置百分比"></el-input-number>
            </el-form-item>
            <el-form-item label="库存减少配置%" prop="roomId">
                <el-input-number v-model="cbConfig.outStock"  :min="1" :max="100" label="库存减少配置百分比"></el-input-number>
            </el-form-item>
            <div class="footer">
                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import {roomPathOptions} from 'mixins'

    export default {
        mixins:[roomPathOptions],
        components: {
        },
        data() {
            return {
                loading:false,
                param:{},
                cbConfig:{
                    currentCbStock:0,//当前库存
                    cbStockDown:0,//库存阈值下线
                    cbStockCent:0,//库存阈值中线
                    cbStockUpper:0,//库存阈值上线
                    cbStockDownOdds:0,//库存阈值下线赔率
                    cbStockCentOdds:0,//库存阈值中线赔率
                    cbStockUpperOdds:0,//库存阈值上线赔率
                    inStock:0,//库存增加配置百分比
                    outStock:0,//库存减少配置百分比
                },
                editLast:{
                    currentCbStock:0,//当前库存
                    cbStockDown:0,//库存阈值下线
                    cbStockCent:0,//库存阈值中线
                    cbStockUpper:0,//库存阈值上线
                    cbStockDownOdds:0,//库存阈值下线赔率
                    cbStockCentOdds:0,//库存阈值中线赔率
                    cbStockUpperOdds:0,//库存阈值上线赔率
                    inStock:0,//库存增加配置百分比
                    outStock:0,//库存减少配置百分比
                },
            }
        },
        created(){
            this.getCbConfigFun();
        },
        methods: {
            ...mapActions('system', ['getcbConfig','setCbConfig']),
            getCbConfigFun(){
                
                this.getcbConfig().then((res) => {
                    this.loading = false;
                    this.cbConfig=res.data;
                    this.editLast=JSON.parse(JSON.stringify(res.data));
                    
                })
            },
            submitForm() {
                this.loading = true;
                this.params={};
                const editLastEntries=Object.entries(this.editLast);
              
                for(const [key , value] of editLastEntries){
                    if(value != this.cbConfig[key]){
                        this.params[key]=this.cbConfig[key];
                    }
                }
                this.setCbConfig(this.params).then(() => {
                    this.loading = false;
                    this.$message.success('修改成功');
                     this.getCbConfigFun();
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        :global(.el-select) {
            width: 100%;
        }
    }

    .footer {
        padding: 20px 0 0 100px;
        text-align: center;
        :global(.el-button) {
            width: 150px;
        }
    }
</style>